import { Controller } from "@hotwired/stimulus"

// Accordion: clicking a section header opens it and closes the others, so only
// one section is expanded at a time.
//
//   <div data-controller="accordion">
//     <div data-accordion-section>
//       <button data-action="accordion#toggle">…<span data-accordion-target="chevron">▸</span></button>
//       <div data-accordion-target="body" hidden>…</div>
//     </div>
//   </div>
export default class extends Controller {
  static targets = ["body", "chevron"]

  toggle(event) {
    const section = event.currentTarget.closest("[data-accordion-section]")
    const body = section.querySelector("[data-accordion-target='body']")
    const chevron = section.querySelector("[data-accordion-target='chevron']")
    const opening = body.hasAttribute("hidden")

    this.bodyTargets.forEach((b) => b.setAttribute("hidden", ""))
    this.chevronTargets.forEach((c) => c.classList.remove("rotate-90"))

    if (opening) {
      body.removeAttribute("hidden")
      chevron?.classList.add("rotate-90")
    }
  }
}
